import * as React from "react";
import { IconButton, styled } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

//region [[ Styles ]]

const ExpandButtonView = styled(IconButton)({});

const Icon = styled(KeyboardArrowDownIcon)((props: { expanded: boolean }) => ({
  transition: "transform 0.5s",
  transform: props.expanded ? "rotate(180deg)" : "rotate(0deg)",
}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface ExpandButtonProps {
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  expanded: boolean;
  className?: string;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const ExpandButton = ({ ...props }: ExpandButtonProps) => {
  return (
    <ExpandButtonView className={props.className} onClick={props.onClick}>
      <Icon expanded={props.expanded} />
    </ExpandButtonView>
  );
};
